import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  contactPageAdditionalMeta,
  contactPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ContactPageMainContainer from '../../components/contact/ContactPageMainContainer';

function ContactPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName="Contact & Bookings"
        desc={`Reach out to ${CompanyName} — LA-based neon-gothic dominatrix, hypnotic goddess, and fire-eater. Submit your booking request or send inquiries for sessions, travel tours, and rituals.`}
        keywords={`Lady Cinder, contact, bookings, Los Angeles dominatrix, neon gothic femdom, hypnosis, fire eater, indoctrination play`}
        additionalMeta={contactPageAdditionalMeta}
        structuredData={contactPageStructuredData}
      />

      {/* Page */}
      <div className="grid overflow-hidden text-colour1 min-h-screen bg-colour2 font-poppins">
        <div className="grid">
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className="grid py-10 px-6 text-center gap-4 place-items-center border-b-4 border-colour6">
            <h1 className="neon_text_heavy_redpink font-titleFont text-4xl md:text-6xl tracking-wider drop-shadow-lg">
              CONTACT & BOOKINGS
            </h1>
            <p className="max-w-2xl text-base md:text-lg leading-relaxed">
              Enter My dominion through devotion and precision. I am{' '}
              <strong>Lady Cinder</strong> — <em>neon-gothic goddess</em>,
              circus freak, and fire-eater. Submit your request for{' '}
              <strong>sensual sadism, indoctrination, or ritual play</strong>. 
              Online or in person, <span className="italic">your obedience begins here</span>.
            </p>
          </header>
        </div>

        {/* Main page content */}
        <ContactPageMainContainer />
      </div>
    </>
  );
}

export default ContactPage;
